
import { getVideoBySEO, getUpNext } from "./../api";
import { options } from "./../common/videooptions";
import { RouteName } from "./routenames";
import { Video } from "./../types";
import UpNext from "./UpNext.vue";

export default {
    components: {
        "upnext": UpNext,
    },

    props: {
        seoname: {
            type: String,
            required: true
        },
        categoryid: {
            type: String,
            required: true
        },
    },

    data() {
        return {
            poster: "",
            video: null,
            upnext: null,
            player: null,
            videoEnded: false,
            countdown: "",
        }
    },

    methods: {
        async initVideo() {
            if(!loadjs.isDefined('videojs')) {
                loadjs(['/js/_video.js'], 'videojs');
            }

            var video: Video = await getVideoBySEO(this.seoname);
            var self = this;
            this.video = video;
            document.title = video.Title;
            if(window.devicePixelRatio > 1) {
                this.poster = video.PosterVideo2x;
            } else {
                this.poster = video.PosterVideo1x;
            }
            this.upnext = await getUpNext(video.Id);

            loadjs.ready('videojs', function(){
                setupVideoTracking();
                self.player = videojs(self.$refs.video, options).ready(function(){
                    this.src(video.Src);
                    this.play();
                    self.player = this;

                    this.on("ended", function () {
                        self.player.poster('');
                        self.videoEnded = true;
                        self.setUpNext();
                    });

                });
                Sharer.init()

            });
        },

        backToCategory() {
            this.$router.replace({
                name: RouteName.CategoryRoute,
                params: {
                    categoryid: this.categoryid,
                },
            });
        },

        cancelAutoplay() {
            this.videoEnded = false;
            this.player.poster(this.poster);
        },

        playNext() {
            this.$router.push({
                name: RouteName.VideoRoute,
                params: {
                    seoname: this.upnext.SeoName,
                    categoryid: this.categoryid,
                },
            });
        },

        setUpNext() {
            var self = this;
            if (self.upNextInterval) {
                clearInterval(self.upNextInterval);
            }
            var time = 8;
            self.countdown = this.$t('gcui_dfw_video.video-channel-35d0a307-up-next-in').replace('<time></time>', time);;
            // $('.modal-video-wrapper-up-next--label time').html(time);
            self.upNextInterval = setInterval(function () {
                time--;
                self.countdown = self.$t('gcui_dfw_video.video-channel-35d0a307-up-next-in').replace('<time></time>', time);;
                if (time == 0) {
                    clearInterval(self.upNextInterval);
                    self.upNextInterval = null;
                    self.playNext();
                    return;
                }
            }, 1000);
        }
    },

    computed: {
        href() {
            return window.location.href;
        },
    },

    mounted() {
        this.initVideo();
    },

    beforeUnmount() {
        if(this.player) {
            this.player.dispose();
        }
    }
}
